export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS';
export const SET_ROLE = 'SET_ROLE';
export const SET_LANG = 'SET_LANG';
export const SET_USER_ID = 'SET_USER_ID';
